import { render, staticRenderFns } from "./AlertDefaultSettingsPerComponent.vue?vue&type=template&id=7e0f5e7b&scoped=true&lang=pug&"
import script from "./AlertDefaultSettingsPerComponent.vue?vue&type=script&lang=ts&"
export * from "./AlertDefaultSettingsPerComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AlertDefaultSettingsPerComponent.vue?vue&type=style&index=0&id=7e0f5e7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0f5e7b",
  null
  
)

export default component.exports